/**
 * Иконки рисуются руками: внешние наборы подключать нельзя — это лишняя
 * зависимость и лишний вес, а бюджет страницы маленький.
 *
 * Все на сетке 24×24, обводкой, одинаковой толщины — так они читаются как
 * один набор, а не как коллекция найденного.
 */
const P = (d: string, extra = "") =>
  `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"${extra}>${d}</svg>`;

const sun = '<circle cx="12" cy="12" r="4.2"/><path d="M12 2.2v2.4M12 19.4v2.4M2.2 12h2.4M19.4 12h2.4M5.1 5.1l1.7 1.7M17.2 17.2l1.7 1.7M18.9 5.1l-1.7 1.7M6.8 17.2l-1.7 1.7"/>';
const moon = '<path d="M20 14.4A8.2 8.2 0 0 1 9.6 4 8.4 8.4 0 1 0 20 14.4z"/>';
const cloud = '<path d="M7.2 19h10a3.8 3.8 0 0 0 .3-7.6 5.6 5.6 0 0 0-10.8-1.2A3.9 3.9 0 0 0 7.2 19z"/>';

export const ICONS: Record<string, string> = {
  /* --- небо --- */
  sun: P(sun),
  moon: P(moon),
  cloud: P(cloud),
  "cloud-sun": P('<circle cx="8" cy="7.6" r="3"/><path d="M8 1.8v1.6M2.2 7.6h1.6M3.9 3.5l1.1 1.1M12.1 3.5L11 4.6"/>' + cloud),
  "cloud-moon": P('<path d="M14.6 7.4A4.6 4.6 0 0 1 8.8 2a4.7 4.7 0 1 0 5.8 5.4z"/>' + cloud),
  drizzle: P(cloud + '<path d="M9 20.6l-.7 1.6M13 20.6l-.7 1.6M17 20.6l-.7 1.6"/>'),
  rain: P(cloud + '<path d="M8.6 20l-1.2 2.6M12.6 20l-1.2 2.6M16.6 20l-1.2 2.6"/>'),
  snow: P(cloud + '<path d="M9 21.4h.01M13 21.4h.01M17 21.4h.01M11 22.6h.01M15 22.6h.01"/>'),
  fog: P('<path d="M4 9.5h16M6 13h12M4 16.5h16M8 20h9"/>'),
  storm: P(cloud + '<path d="M13.4 20l-3.4 0 2.2 4 -3.2-1"/>'),

  /* --- плеер --- */
  play: P('<path d="M8 5.2l11.5 6.8L8 18.8z"/>', ' class="filled"'),
  pause: P('<path d="M9.2 5v14M15.2 5v14"/>'),
  prev: P('<path d="M7 6v12M19 6l-9.4 6 9.4 6z"/>'),
  next: P('<path d="M17 6v12M5 6l9.4 6L5 18z"/>'),
  volume: P('<path d="M4 9.4h3.4L12 5.6v12.8L7.4 14.6H4z"/><path d="M15.6 9.6a3.6 3.6 0 0 1 0 4.8"/><path d="M18.2 7a7 7 0 0 1 0 10"/>'),
  mute: P('<path d="M4 9.4h3.4L12 5.6v12.8L7.4 14.6H4z"/><path d="M16.2 9.8l4.4 4.4M20.6 9.8l-4.4 4.4"/>'),

  /* --- интерфейс --- */
  pin: P('<path d="M12 21.6s6.6-6.2 6.6-11a6.6 6.6 0 1 0-13.2 0c0 4.8 6.6 11 6.6 11z"/><circle cx="12" cy="10.6" r="2.4"/>'),
  search: P('<circle cx="10.8" cy="10.8" r="6.4"/><path d="M15.6 15.6L21 21"/>'),
  wind: P('<path d="M3 8.4h11a2.9 2.9 0 1 0-2.9-2.9M3 12.6h15.2a2.9 2.9 0 1 1-2.9 2.9M3 16.8h8"/>'),
  theme: P('<circle cx="12" cy="12" r="8.2"/><path d="M12 3.8v16.4a8.2 8.2 0 0 0 0-16.4z" class="filled"/>'),
  lang: P('<circle cx="12" cy="12" r="8.4"/><path d="M3.6 12h16.8M12 3.6a13 13 0 0 1 0 16.8 13 13 0 0 1 0-16.8"/>'),
  photo: P('<rect x="3.2" y="5.4" width="17.6" height="13.2" rx="1.8"/><circle cx="9" cy="10.4" r="1.7"/><path d="M4 16.8l4.6-4 3.2 2.6 3-2.4 5 4.2"/>'),

  /* --- показания погоды --- */
  thermo: P('<path d="M14 14.2V5.4a2 2 0 1 0-4 0v8.8a4.4 4.4 0 1 0 4 0z"/><path d="M12 9.4v5.6"/>'),
  drop: P('<path d="M12 3.2s6 6.6 6 10.4a6 6 0 0 1-12 0C6 9.8 12 3.2 12 3.2z"/>'),
  gauge: P('<path d="M4.2 17.4a8.6 8.6 0 1 1 15.6 0"/><path d="M12 14.6l3.6-4"/><circle cx="12" cy="15.4" r="1.2" class="filled"/>'),
  cloudy: P('<path d="M7.2 18.4h9.6a3.6 3.6 0 0 0 .3-7.2 5.4 5.4 0 0 0-10.3-1.1A3.7 3.7 0 0 0 7.2 18.4z"/>'),
  install: P('<path d="M12 3.6v11.2M7.6 10.6l4.4 4.4 4.4-4.4"/><path d="M4.4 19.4h15.2"/>'),
};

export const icon = (name: string, cls = "ic") =>
  `<span class="${cls}">${ICONS[name] ?? ICONS.cloud}</span>`;
